import React from 'react';
import { Countdown } from './Countdown';
import { Cta } from './Cta';
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
export function Ofertas() {
  const hoy = DIAS[new Date().getDay()];
  return <section id="ofertas" aria-labelledby="oferta-titulo" className="w-full bg-canvas px-6 py-20" data-id="element-153" data-mp="2rk1ckuh0ds9n">
      <div className="mx-auto max-w-2xl" data-id="element-154" data-mp="2mlzuocvbjyzr">
        <div className="overflow-hidden rounded-3xl border-2 border-brand-500 bg-surface shadow-lift" data-id="element-155" data-mp="1yvm8h2zf0ud3">
          <div className="bg-brand-500 px-6 py-3 text-center" data-id="element-156" data-mp="1tx14csh1lqjd">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-ink" data-id="element-157" data-mp="1tuogxzsimnyx">
              Oferta válida solo hoy {hoy}
            </p>
          </div>

          <div className="px-6 py-10 text-center sm:px-10" data-id="element-158" data-mp="23txhxclst2us">
            <h2 id="oferta-titulo" className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-159" data-mp="1g5e8uuuxcm1n">
              El precio de lanzamiento cierra a medianoche
            </h2>
            <p className="mt-3 text-sm text-muted" data-id="element-160" data-mp="1b47311ccdwxm">Después vuelve a su valor habitual de $137 USD.</p>

            <div className="mt-8" data-id="element-161" data-mp="rsizt9mjd7q6">
              <Countdown data-id="element-162" data-mp="vvp2k7afwgrw" />
            </div>

            <div className="mt-9 flex flex-col items-center" data-id="element-163" data-mp="vunodty4ne5y">
              <Cta data-id="element-164" data-mp="10mnktceznoxs">Obtener el acceso AHORA →</Cta>
              <p className="mt-3 text-xs text-muted" data-id="element-165" data-mp="10p0c4g6mzbni">
                Acceso inmediato · Pago único · Garantía de 7 días
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 rounded-3xl border border-edge bg-surface p-8" data-id="element-166" data-mp="8xkhbyuxeim7">
          <h3 className="font-display text-xl font-bold text-ink" data-id="element-167" data-mp="cye7yzzr6bis">💱 Pagá fácilmente desde tu país</h3>
          <p className="mt-4 text-sm leading-relaxed text-muted" data-id="element-168" data-mp="hvo3mxdqjjf2">
            Aunque el precio está expresado en dólares, la plataforma realiza automáticamente la conversión a
            tu moneda local al momento del pago. Podés completar tu compra con tu tarjeta habitual, sin hacer
            cálculos ni trámites adicionales.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-muted" data-id="element-169" data-mp="18mjwr8nzk333">
            Antes de confirmar, podrás visualizar el importe correspondiente según el tipo de cambio aplicado
            por tu medio de pago.
          </p>
        </div>
      </div>
    </section>;
}